

export default {
  choose: 'اختر {n}',
};
